import React, { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import './scss/style.scss'
import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import DefaultLayout from './layout/DefaultLayout'
import Login from './views/login/Login'
import { useDispatch, useSelector } from 'react-redux'
import { clearMsg } from './Actions/Admin/adminActions'
const App = () => {
  const {token} = useSelector((state) => state.admin)
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={token ? <Navigate to="/dashboard" /> : <Login />} />
        <Route path="/*" element={token ? <DefaultLayout /> : <Navigate to="/admin" />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App


